export default {
    manage_createEditInput_EditTitle: "Edit Input Label",
    manage_createEditInput_CreateTitle: "Create Input Label",
    manage_createEditInput_success: "Input Label was created successfully",
    manage_createEditInput_success_edit: "Input Label was updated successfully",
    manage_createEditInput_duplicatedInputErrorMessage: "This Input Label already exists",
    manage_createEditInput_TitleInputLabel: "Input Label",
    manage_createEditInput_onLabelInputLabel: "Input ON Label",
    manage_createEditInput_offLabelInputLabel: "Input OFF Label",
    manage_createEditInput_warning_characters: "The input label cannot contain emojis",
    manage_createEditInput_warning_characters_onLabel: "The input ON label cannot contain emojis",
    manage_createEditInput_warning_characters_offLabel: "The input OFF label cannot contain emojis",
}